"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submittedItem = exports.submittedArtifactList = exports.submissionSet = exports.omitProcessed = exports.inProgressDefaultSet = exports.completeSet = exports.defaultSet = void 0;
var case_1 = require("../../fixtures/case/case");
var submitted_collection_fixture_1 = require("./submitted-collection.fixture");
var artifact_utils_1 = require("./artifact-utils");
var utils_1 = require("../utils/utils");
var CaseArtifactTypes;
(function (CaseArtifactTypes) {
    CaseArtifactTypes["ASSEMBLED"] = "ASSEMBLED";
    CaseArtifactTypes["MAPPED"] = "MAPPED";
    CaseArtifactTypes["CLINICAL"] = "CLINICAL";
    CaseArtifactTypes["PREDICTION"] = "PREDICTION";
    CaseArtifactTypes["PROCESSED"] = "PROCESSED";
    CaseArtifactTypes["SUBMITTED"] = "SUBMITTED";
    CaseArtifactTypes["CLAIM"] = "CLAIM";
    CaseArtifactTypes["REMITTANCE"] = "REMITTANCE";
    CaseArtifactTypes["REFERRAL"] = "REFERRAL";
    CaseArtifactTypes["CODED"] = "CODED";
})(CaseArtifactTypes || (CaseArtifactTypes = {}));
var defaultSet = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.PROCESSED,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
exports.defaultSet = defaultSet;
var submissionSet = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.PROCESSED,
    CaseArtifactTypes.SUBMITTED,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
exports.submissionSet = submissionSet;
var omitProcessed = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
exports.omitProcessed = omitProcessed;
var inProgressDefaultSet = new Set([
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.ASSEMBLED,
    CaseArtifactTypes.CODED // codes sent to the payer.
]);
exports.inProgressDefaultSet = inProgressDefaultSet;
var completeSet = new Set([
    CaseArtifactTypes.MAPPED,
    CaseArtifactTypes.CLINICAL,
    CaseArtifactTypes.PREDICTION,
    CaseArtifactTypes.PROCESSED,
    CaseArtifactTypes.SUBMITTED,
    CaseArtifactTypes.ASSEMBLED,
    CaseArtifactTypes.CLAIM,
    CaseArtifactTypes.REMITTANCE,
    CaseArtifactTypes.REFERRAL,
    CaseArtifactTypes.CODED
]);
exports.completeSet = completeSet;
var getCaseRun = function (detail, activeProcessId) {
    if (activeProcessId === void 0) { activeProcessId = -1; }
    var caseRuns = (detail === null || detail === void 0 ? void 0 : detail.caseRuns) || [];
    if (!caseRuns.length) {
        throw new Error("no case runs available");
    }
    if (activeProcessId === -1) {
        var primaryRun = caseRuns.find(function (run) { return run.primary_process_indicator; });
        return primaryRun || detail.caseRuns[0];
    }
    var activeCaseRun = caseRuns.find(function (run) { return run.process_instance_id === activeProcessId; });
    return activeCaseRun || detail.caseRuns[0];
};
var getArtifactSet = function (toggleAll, caseRun) {
    if (toggleAll) {
        return completeSet;
    }
    else {
        var artSet = new Set(caseRun.artifacts.map(function (artifact) { return artifact.type; }));
        if (artSet.has("SUBMITTED") ||
            caseRun.submitter_process === false) {
            return submissionSet;
        }
        else if (artSet.has("PROCESSED")) {
            return defaultSet;
        }
        else {
            return inProgressDefaultSet;
        }
    }
};
var automatedCaseRun = (0, utils_1.cloneDeep)(getCaseRun(case_1.automatedCase));
automatedCaseRun.submitter_process = false;
var submittedItem = (0, utils_1.cloneDeep)(getCaseRun(case_1.radFootCase));
exports.submittedItem = submittedItem;
submittedItem.artifacts = submitted_collection_fixture_1.submittedCollection;
var submitterSet = new Set(["SUBMITTED"]);
var artifactSet = getArtifactSet(false, automatedCaseRun);
var submittedArtifactList = (0, artifact_utils_1.filterAndAssembleArtifactList)({
    //@ts-ignore
    caseRun: case_1.automatedCase,
    artifactSet: artifactSet,
    importedCaseRun: submittedItem,
    importedSet: submitterSet
});
exports.submittedArtifactList = submittedArtifactList;
//# sourceMappingURL=submitted-artifact.js.map